import pegasus from "../../assets/scripts/global/01-pegasus";

document.addEventListener("alpine:init", () => {
    Alpine.data("navigation", () => ({
        isMobile: true,
        menuOpen: false,
        mobMenuOpen: false,
        mobMegaMenu: null,
        mobSubMenu: null,
        mobSubMenuLevel3: null,
        megaMenuOpen: null,
        level1Active: null,
        level2Active: null,
        level3Active: null,
        isMobileMenuOpen: false,
        ctaColor: null,
        isFixed: false,
        nav: null,
        navHeight: 0,
        positionTop: 0,
        searchOpen: false,
        init() {
            this.nav = this.$refs.navBar;
            this.positionTop = pegasus.getElemOffset(this.$el);
            
            // Initial check for navigation state
            this.checkNavHeight();
            this.fix();

            pegasus.onResizeFinished(() => {
                this.isMobile = window.outerWidth <= 1280;

                setTimeout(() => {
                    this.checkNavHeight();
                    this.fix();
                }, 200);
            }, true);

            // Close mega menu when clicking outside
            document.addEventListener('click', (e) => {
                if (!e.target.closest('.mega') && !e.target.closest('[x-data="navigation"]')) {
                    this.closeAll();
                }
            });

            // Handle scroll for fixed navigation
            window.addEventListener('scroll', () => {
                this.checkNavHeight();
            }, true);
        },
        checkNavHeight() {
            const nav = document.querySelector('.nav');
            if (nav) {
                const navHeight = nav.offsetHeight;
                const scrollPosition = window.scrollY;
                this.isFixed = scrollPosition > navHeight;
            }
        },
        fix() {
            const scrollPosition = window.scrollY;
            const navHeight = this.nav.offsetHeight;
            
            if (scrollPosition <= this.positionTop.top) {
                this.isFixed = false;
            } else {
                this.isFixed = true;
            }
        },
        openMobNav() {
            this.closeAll();
            this.navZedTop();
            this.mobMenuOpen = true;
            this.lockScroll();
            window.dispatchEvent(new CustomEvent("pegasus-mobnav-open"));
        },
        openMegaNav(id) {
            if (this.megaMenuOpen === id) {
                this.closeAll();
            } else {
                this.megaMenuOpen = id;
                this.level1Active = null;
                this.level2Active = null;
                this.level3Active = null;
                this.lockScroll();
            }
        },
        closeAll() {
            document
                .getElementById("page-header")
                .style.removeProperty("z-index");
            this.megaMenuOpen = null;
            this.level1Active = null;
            this.level2Active = null;
            this.level3Active = null;
            this.mobMenuOpen = false;
            this.mobSubMenu = null;
            this.mobSubMenuLevel3 = null;
            this.ctaColor = null;
            this.unlockScroll();
            window.dispatchEvent(new CustomEvent("pegasus-mobnav-close"));
        },
        navZedTop() {
            document.getElementById("page-header").style.zIndex = "9999";
        },
        lockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
        },
        unlockScroll() {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        },
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
            if (this.isMobileMenuOpen) {
                this.lockScroll();
                window.dispatchEvent(new CustomEvent("pegasus-mobnav-open"));
            } else {
                this.unlockScroll();
            }
        }
    }));
});
